import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { TranstationFactory } from '../core/translation.factory';
import { HttpClient } from '@angular/common/http';
import { Idle } from "@ng-idle/core";
import { UserFactory } from '../core/user.factory';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';

@Injectable({
    providedIn: 'root'
})
export class SessionTimeoutService {
    constructor(
        private http: HttpClient,
        public idle: Idle,
        private router: Router,
        private userFactory: UserFactory,
        private localize: LocalizeRouterService,
        private translate: TranstationFactory
    ) { }

    private expiredTimeinterval = null;
    private expipredTime = null;

    private logout() {
        this.http.get<any>(env.apiEndpoint + '/auth/logout').subscribe(res => {
            this.idle.stop();

            this.userFactory.signOut();
            this.stopTokenExpiredClock();

            if (env.isSso) {
                const urlLogoutWithADB2C = `${env.logoutUrl}`;
                console.log('url: ', urlLogoutWithADB2C);
                this.clearSeesion();
                window.location.href = urlLogoutWithADB2C;
            } else {
                const translatedPath: any = this.localize.translateRoute('/login');
                this.clearSeesion();
                this.router.navigate([translatedPath]);
            }
        });
    }

    private clearSeesion() {
        sessionStorage.clear();
        localStorage.clear();
    }

    public stopTokenExpiredClock() {
        if (this.expiredTimeinterval != null) {
            clearInterval(this.expiredTimeinterval);
            this.expiredTimeinterval = null;
        }
    }

    public startTokenExpiredClock(exp) {
        if (this.expiredTimeinterval != null) {
            return;
        }

        this.expipredTime = Date.parse(exp);
        //TODO temp timer for testing
        //this.expipredTime = new Date().getTime() + (10 * 60 * 1000);

        const warnCountdown = env.sessionTimeoutWarningMin;
        //TODO temp timer for testing
        //const warnCountdown = 5;

        this.expiredTimeinterval = setInterval(() => {
            const now = new Date().getTime();
            const countdown = Math.floor((this.expipredTime - now) / (1000));

            //console.log(countdown);

            if (countdown <= (warnCountdown * 60)) {
                //Refresh Token
                if (this.userFactory.getToken() !== null) {
                    this.http.post<any>(env.apiEndpoint + '/auth/refreshToken', {
                        refreshToken: this.userFactory.getRefreshToken()
                    }).subscribe(res => {
                        this.userFactory.saveToken(res.accessToken);
                        this.userFactory.saveRefreshToken(res.refreshToken);

                        this.stopTokenExpiredClock();
                        this.http.post<any>(env.apiEndpoint + '/auth/getTokenExpiredDate', {}).subscribe(response => {
                            this.startTokenExpiredClock(response);
                        });
                    });
                }
            }
            else if (countdown <= 0) {
                this.stopTokenExpiredClock();

                if (Swal.isVisible()) {
                    Swal.close();
                }

                Swal.fire({
                    title: this.translate.get('token_expired_error_title'),
                    html: this.translate.get('token_expired_error_html'),
                    type: 'error'
                }).then((result) => {
                    //log out
                    this.logout();
                });
            }
        }, 1000);
    }
}